import * as React from 'react'
import { useParams } from 'react-router-dom'

import { useCalendarLeaves } from 'modules/calendar/hooks/useCalendarLeaves'
import RejectLeave from 'modules/timeoff/components/RejectLeave'
import { useOnCloseCalendar } from 'modules/timeoff/hooks/useOnCloseCalendar'

const CalendarRejectLeavePage = () => {
  const { leave_id: leaveId } = useParams()
  const onClose = useOnCloseCalendar()
  const { onChangeLeave } = useCalendarLeaves()

  return leaveId !== undefined ? (
    <RejectLeave leaveId={parseInt(leaveId, 10)} onClose={onClose} onRejected={onChangeLeave} />
  ) : null
}

export default CalendarRejectLeavePage
